import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { CreateTagRequest } from '@ps/feature-tags';
import { TagsActions } from './tags.actions';

@Injectable({ providedIn: 'root' })
export class TagsActionsFacade {
  private readonly _store = inject(Store);

  public loadTags(): void {
    this._store.dispatch(TagsActions.loadTags());
  }

  public createTag(request: CreateTagRequest): void {
    this._store.dispatch(TagsActions.createTag({ request }));
  }
}
